import styled from 'styled-components';
import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionProjectTagProps extends PropsWithChildren {
  className?: string;
  isAnimated?: boolean;
}

export const MotionProjectTag = ({
  children,
  className,
  isAnimated = false,
}: MotionProjectTagProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.tag.amount,
  });

  return (
    <MotionProjectTagWrapper 
      className={className}
      ref={ref}
      {...(isAnimated ? {
        initial: { opacity: 0, y: ANIMATION_CONFIG.tag.yOffset },
        animate: isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: ANIMATION_CONFIG.tag.yOffset },
        transition: { 
          duration: ANIMATION_CONFIG.tag.duration,
        }
      } : {})}
    >
      {children}
    </MotionProjectTagWrapper>
  );
};

const MotionProjectTagWrapper = styled(motion.span)``;
